import helpers from './helpers';

export function makeRankColumn(renderFn, width = 80) {
  return {
    title: '排名',
    key: 'ranking',
    render: renderFn,
    width,
  };
}

export const userIdColumn = {
  title: '用戶ID',
  dataIndex: 'userid',
  key: 'userid',
  ellipsis: true,
  render: (text) => helpers.renderUserLink(text),
};

export const nicknameColumn = {
  title: '暱稱',
  dataIndex: 'nickname',
  key: 'nickname',
  ellipsis: true,
};

export const markColumn = {
  title: '分數',
  dataIndex: 'mark',
  key: 'mark',
};

export const addTimeColumn = {
  title: '時間',
  dataIndex: 'addtime',
  key: 'addtime',
  render: (text) => helpers.formatAddTime(text),
};

export const topRankCountColumn = {
  title: '上榜次數',
  dataIndex: 'top_rank_count',
  key: 'top_rank_count',
  render: (count) => (
    <span style={{
      fontWeight: 'bold',
      color: count >= 30 ? '#FF6B6B' : count >= 15 ? '#FFB347' : '#4ECDC4'
    }}>
      {count} 次
    </span>
  ),
  width: 120,
};

const columnsFactory = {
  makeRankColumn,
  userIdColumn,
  nicknameColumn,
  markColumn,
  addTimeColumn,
  topRankCountColumn,
};

export default columnsFactory;
